import React, { createContext, useState, useEffect, ReactNode, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageContextType {
  language: string;
  changeLanguage: (lng: string) => void;
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

interface LanguageProviderProps {
  children: ReactNode;
}

export function LanguageProvider({ children }: LanguageProviderProps) {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState<string>(localStorage.getItem('language') || 'id');

  useEffect(() => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language);
  }, [language, i18n]);

  // Stabilkan fungsi changeLanguage dengan useCallback
  const changeLanguage = useCallback((lng: string) => {
    setLanguage(lng);
  }, []); // Kosongkan dependency array karena fungsi ini tidak bergantung pada nilai eksternal

  const value = useMemo(
    () => ({
      language,
      changeLanguage,
    }),
    [language, changeLanguage], // Sekarang changeLanguage stabil
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}
